var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a4ebcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6efc3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7709",
    "data-name": "Group 7709",
    transform: "translate(-1055 -1189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1361",
    "data-name": "Rectangle 1361",
    width: 32,
    height: 32,
    rx: 10,
    transform: "translate(1055 1189)",
    fill: "#37c78e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7710",
    "data-name": "Group 7710",
    transform: "translate(1058.3 1198.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M138.915,208.4a2.2,2.2,0,1,0-2.2-2.2,2.2,2.2,0,0,0,2.2,2.2Zm0,1.463c-2.354,0-4.886,1.247-4.886,2.792v1.6H143.8v-1.6C143.8,211.106,141.269,209.858,138.915,209.858Zm-15.63-1.463a2.2,2.2,0,1,0-2.2-2.2,2.2,2.2,0,0,0,2.2,2.2Zm0,1.463c-2.354,0-4.886,1.247-4.886,2.792v1.6h9.771v-1.6C128.171,211.106,125.639,209.858,123.286,209.858Z",
    transform: "translate(-118.4 -200.577)",
    opacity: 0.62,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M204.238,163.758a2.929,2.929,0,1,0-2.933-2.925A2.923,2.923,0,0,0,204.238,163.758Zm0,1.96c-3.3,0-6.838,1.752-6.838,3.906v1.953h13.677v-1.953C211.077,167.463,207.535,165.718,204.238,165.718Z",
    transform: "translate(-191.534 -157.9)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.e34b99a8368407d3cf9b804a5339f002.svg";
export { ForwardRef as ReactComponent };